import React, { useState, useEffect } from 'react';

const Calendar = () => {
  const events = {
    '14 January 2025': ['Makar Sankranti', 'Pongal'],
    '5 February 2025': ['Vasant Panchami'],
    '26 February 2025': ['Maha Shivaratri'],
    '13 March 2025': ['Holika Dahan'],
    '14 March 2025': ['Holi'],
    '30 March 2025': ['Ugadi', 'Gudi Padwa', 'Chaitra Navratri Begins'],
    '31 March 2025': ['Chaitra Navratri Day 2'],
    '1 April 2025': ['Chaitra Navratri Day 3'],
    '2 April 2025': ['Chaitra Navratri Day 4'],
    '3 April 2025': ['Chaitra Navratri Day 5'],
    '4 April 2025': ['Chaitra Navratri Day 6'],
    '5 April 2025': ['Chaitra Navratri Day 7'],
    '6 April 2025': ['Rama Navami (Chaitra Navratri Ends)'],
    '12 April 2025': ['Hanuman Jayanti'],
    '14 April 2025': ['Solar New Year', 'Baisakhi'],
    '30 April 2025': ['Akshaya Tritiya'],
    '4 May 2025': ['Sunderkand MahaPaath'],
    '12 May 2025': ['Buddha Purnima'],
    '9 August 2025': ['Raksha Bandhan'],
    '15 August 2025': ['Janmashtami'],
    '26 August 2025': ['Ganesh Chaturthi'],
    '8 October 2025': ['Sharad Navratri Begins'],
    '9 October 2025': ['Sharad Navratri Day 2'],
    '10 October 2025': ['Sharad Navratri Day 3'],
    '11 October 2025': ['Sharad Navratri Day 4'],
    '12 October 2025': ['Sharad Navratri Day 5'],
    '13 October 2025': ['Sharad Navratri Day 6'],
    '14 October 2025': ['Sharad Navratri Day 7'],
    '15 October 2025': ['Durga Ashtami (Sharad Navratri Day 8)'],
    '16 October 2025': ['Navami (Sharad Navratri Ends)'],
    '19 October 2025': ['Dhanteras'],
    '20 October 2025': ['Diwali'],
    '22 October 2025': ['Govardhan Puja'],
    '23 October 2025': ['Bhai Dooj'],
    '27 October 2025': ['Chhath Puja'],
    '5 November 2025': ['Guru Nanak Jayanti'],
  };

  const [currentDate, setCurrentDate] = useState(new Date());

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  useEffect(() => {
    setDaysInMonth(getDaysInMonth(currentDate));
    setFirstDayOfMonth(getFirstDayOfMonth(currentDate));
  }, [currentDate]);

  const [daysInMonth, setDaysInMonth] = useState(getDaysInMonth(currentDate));
  const [firstDayOfMonth, setFirstDayOfMonth] = useState(
    getFirstDayOfMonth(currentDate),
  );

  const goToPreviousMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1),
    );
  };

  const goToNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    );
  };

  const dayLabels = ['SUN', 'MON', 'TUES', 'WED', 'THURS', 'FRI', 'SAT'];

  const renderDays = () => {
    const cells = [];

    // Day Labels
    for (let i = 0; i < 7; i++) {
      cells.push(
        <div
          key={`day-label-${i}`}
          className="h-[30px] px-3 py-1 text-[#535252] w-full sm:w-[180px] text-left bg-white border border-[#E8E8E8] font-bold uppercase"
        >
          {dayLabels[i]}
        </div>,
      );
    }

    // Empty Cells for Days Before Month Starts
    for (let i = 0; i < firstDayOfMonth; i++) {
      cells.push(
        <div
          key={`empty-${i}`}
          className="h-[140px] w-full sm:w-[180px] bg-white border border-[#E8E8E8]"
        ></div>,
      );
    }

    // Days of the Month
    for (let day = 1; day <= daysInMonth; day++) {
      const currentDateFormatted = `${day} ${
        months[currentDate.getMonth()]
      } ${currentDate.getFullYear()}`;
      const eventForDay = events[currentDateFormatted] || [];
      cells.push(
        <div
          key={day}
          className={`h-[140px] w-full sm:w-[180px] bg-white border border-[#E8E8E8] p-2 ${
            eventForDay.length > 0 ? 'bg-blue-100' : ''
          }`}
        >
          <div className="text-[20px] font-bold text-left text-[#535252]">
            {day}
          </div>
          <ul className="mt-2 space-y-2">
            {eventForDay.map((event, index) => (
              <li
                key={index}
                className="text-sm text-blue-800 font-semibold bg-blue-200 px-2 py-1 rounded"
              >
                {event}
              </li>
            ))}
          </ul>
        </div>,
      );
    }

    return cells;
  };

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return (
    <div className="w-full px-4 sm:px-20 mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={goToPreviousMonth}
          className="bg-gray-200 px-2 py-1 rounded text-sm sm:text-base"
        >
          Previous
        </button>
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
          {months[currentDate.getMonth()]}, {currentDate.getFullYear()}
        </h2>
        <button
          onClick={goToNextMonth}
          className="bg-gray-200 px-2 py-1 rounded text-sm sm:text-base"
        >
          Next
        </button>
      </div>
      <div className="grid grid-cols-7 text-left">{renderDays()}</div>
    </div>
  );
};

export default Calendar;
